// This file contains utility functions for generating random data.

export const generateRandomString = (prefix = '', length = 8): string => {
  return (
    prefix +
    Math.random()
      .toString(36)
      .substring(2, 2 + length)
  );
};

export const randomFromArray = <T>(array: T[]): T => {
  return array[Math.floor(Math.random() * array.length)];
};

export const randomDateInRange = (months = 6): string => {
  const now = new Date();
  const future = new Date();
  future.setMonth(now.getMonth() + months);
  const randomDate = new Date(
    now.getTime() + Math.random() * (future.getTime() - now.getTime()),
  );
  return randomDate.toISOString();
};

export const expirationDateInRange = (): string => {
  const now = new Date();
  const expirationDate = new Date(now);
  expirationDate.setDate(now.getDate() + 10);
  return expirationDate.toISOString();
};

export const generateRandomAmount = (min = 100000, max = 1000000): string => {
  return (Math.floor(Math.random() * (max - min)) + min).toString();
};

export const randomAwsAccountId = (): string => {
  // Generate 12 numeric digits for the AWS account ID
  const min = 100000000000; // 12 digits, starting with 1
  const max = 999999999999; // 12 digits, all 9's
  return Math.floor(min + Math.random() * (max - min)).toString();
};
